var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center cursor-pointer",on:{"click":function($event){return _vm.$router.push({name: 'suporte.cliente.dashboard'})}}},[_c('PosMenuIcon',{attrs:{"name":"headset","icon-type":"fa","icon-style":"light"}}),_c('span',{staticClass:"m-r m-l-n font-10 font-bold text-blue"},[_vm._v("Suporte")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }